/**
 * Leva os campos de perfil do `signup-id` até o `signup-password`.
 *
 * Nome, sobrenome, nascimento, gênero e nome da mãe são digitados no step 1,
 * mas quem cria a conta é o `signup()` da tela de senha — e é o corpo *dessa*
 * chamada que a Action `pre-user-registration` lê para gravar `user_metadata`.
 * A Auth0 só devolve em `screen.data` os identificadores que ela conhece
 * (CPF, e-mail, telefone), então os `ulp-*` precisam atravessar por fora.
 *
 * Mesmo mecanismo do token de verificação: `sessionStorage`, mesma aba, morre
 * com ela. Aqui não há consumo único — um envio que falha pode ser repetido,
 * e um cadastro novo na mesma aba sobrescreve o anterior.
 */

const KEY = 'alelo_signup_profile'

export function save(fields: Record<string, string>): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(fields))
  } catch {
    // Storage indisponível: o cadastro segue sem os campos de perfil.
  }
}

export function read(): Record<string, string> {
  let raw: string | null = null
  try {
    raw = sessionStorage.getItem(KEY)
  } catch {
    return {}
  }
  if (!raw) return {}

  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>
    const fields: Record<string, string> = {}
    for (const [key, value] of Object.entries(parsed)) {
      if (typeof value === 'string') fields[key] = value
    }
    return fields
  } catch {
    return {}
  }
}

export function clear(): void {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // nada a fazer
  }
}
